module.exports = __webpack_public_path__ + "img/xasc.f14542e7.png";